/* eslint-disable no-console */

import { register } from 'register-service-worker'

// console.log('Environment:', process.env.DEPLOYMENT_ENV)
if (process.env.VUE_APP_DEPLOYMENT_ENV === 'local') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ type: 'UPDATE_FOUND' })
      }
    },
    updated () {
      console.log('New content is available; please refresh.')
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ type: 'UPDATE_COMPLETED' })
      }
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ type: 'OFFLINE' })
      }
    },
    online () {
      console.log('Internet connection found. App is running in online mode.')
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ type: 'ONLINE' })
      }
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}

// Additional logging to check if the service worker is controlling the page
if (navigator.serviceWorker) {
  navigator.serviceWorker.ready.then(registration => {
    console.log('Service Worker is ready')
  }).catch(error => {
    console.error('Service Worker registration failed:', error)
  })

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    console.log('Service Worker controller changed')
  })

  // Listen for messages from the service worker
  navigator.serviceWorker.addEventListener('message', event => {
    console.log('Received message from service worker:', event.data)
  })
}
